import { render, staticRenderFns } from "./MediaModal.vue?vue&type=template&id=6b4f07a4&"
import script from "./MediaModal.vue?vue&type=script&lang=js&"
export * from "./MediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports